import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPlusCircle, FaTimesCircle } from "react-icons/fa";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import SuccessModal from "./SuccessModal";

function MemberForm({ onSubmit, setShowForm }) {
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [status, setStatus] = useState(true);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // Estado para el mensaje de éxito
  const [showSuccessModal, setShowSuccessModal] = useState(false); // Estado para el modal
  
  // Esquema de validación con Yup
  const validationSchema = Yup.object({
    name: Yup.string()
      .trim()
      .required("El nombre es obligatorio.")
      .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñÜü\s]+$/, "El nombre solo puede contener letras y espacios."),
    surname: Yup.string()
      .trim()
      .required("El apellido es obligatorio.")
      .matches(/^[A-Za-zÁÉÍÓÚáéíóúÑñÜü\s]+$/, "El apellido solo puede contener letras y espacios."),
    birthdate: Yup.date().required("La fecha de nacimiento es obligatoria."),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
  
    // Validación con Yup
    validationSchema
      .validate({ name, surname, birthdate }, { abortEarly: false })
      .then(() => {
        setIsSubmitting(true);
  
        // Convertir la fecha a UTC
        const birthdateUTC = new Date(birthdate).toISOString().split("T")[0];
  
        const newMember = {
          name,
          surname,
          birthdate: birthdateUTC, // Usar la fecha UTC aquí
          school: {
            id: 4,
            name: "Escuela de Test 1",
          },
          status,
        };
  
        onSubmit(newMember);
        setIsSubmitting(false);
        //setShowSuccessModal(true)
        setShowForm(false);
        
        setSuccessMessage("Miembro creado exitosamente!");
  
        // Limpiar el formulario (opcional)
        setName("");
        setSurname("");
        setBirthdate("");
        setStatus(true);
      })
      .catch((err) => {
        const validationErrors = {};
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        setErrors(validationErrors);
      });
  };
  

  // Función para capitalizar la primera letra de cada palabra
  const capitalizeFirstLetter = (string) => {
    return string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-primary text-white text-center">
          <h5 className="mb-0">Crear Nuevo Miembro</h5>
        </div>
        <div className="card-body">
          {Object.keys(errors).length > 0 && (
            <div className="alert alert-danger">
              {Object.values(errors).map((error, idx) => (
                <p key={idx}>{error}</p>
              ))}
            </div>
          )}

          {/* Mensaje de éxito */}
          {successMessage && (
            <div className="alert alert-success">
              {successMessage}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(capitalizeFirstLetter(e.target.value))}
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                required
                placeholder="Nombre"
              />
              <label htmlFor="name">Nombre:</label>
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>
            <div className="form-floating mb-3">
              <input
                type="text"
                id="surname"
                value={surname}
                onChange={(e) => setSurname(capitalizeFirstLetter(e.target.value))}
                className={`form-control ${errors.surname ? "is-invalid" : ""}`}
                required
                placeholder="Apellido"
              />
              <label htmlFor="surname">Apellido:</label>
              {errors.surname && <div className="invalid-feedback">{errors.surname}</div>}
            </div>
            
            {/*Selector de Fecha*/}
            <div className="form-floating mb-3">
              <input
                type="date"
                id="birthdate"
                value={birthdate}
                onChange={(e) => setBirthdate(e.target.value)}
                className={`form-control ${errors.birthdate ? "is-invalid" : ""}`}
                required
                placeholder="Fecha de Nacimiento"
              />
              <label htmlFor="birthdate">Fecha de Nacimiento:</label>
              {errors.birthdate && <div className="invalid-feedback">{errors.birthdate}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label">Estado:</label>
              <select
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value === "true")}
              >
                <option value={true}>Activo</option>
                <option value={false}>Inactivo</option>
              </select>
            </div>

            <div className="d-flex gap-2">
              <button type="submit" disabled={isSubmitting} className="btn btn-primary w-50">
                {isSubmitting}
                <FaPlusCircle className="ms-2" /> Nuevo Miembro
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary w-50"
                onClick={() => setShowForm(false)}
              >
                Cancelar <FaTimesCircle className="ms-2" />
              </button>
            </div>
          </form>
        </div>
      </div>
    <SuccessModal isOpen={showSuccessModal} onClose={() => setShowSuccessModal(false)} />

    </div>
    
  );
}

export default MemberForm;
